export default __webpack_public_path__ + "static/media/cart.c3e1e59c.svg";